export const icons = {
  EN: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
    <defs>
      <clipPath id="clip-path-2">
        <circle id="Ellipse_303" data-name="Ellipse 303" cx="8" cy="8" r="8" transform="translate(-18967 -323)" fill="#fff" stroke="#707070" stroke-width="1"/>
      </clipPath>
    </defs>
    <g id="Mask_Group_7" data-name="Mask Group 7" transform="translate(18967 323)" clip-path="url(#clip-path)">
      <g id="Group_255" data-name="Group 255" transform="translate(-18967.889 -324.013)">
        <rect id="Rectangle_389" data-name="Rectangle 389" width="16" height="16.25" transform="translate(0.888 0.763)" fill="#0955b2"/>
        <rect id="Rectangle_383" data-name="Rectangle 383" width="22.627" height="2.513" transform="translate(0 16) rotate(-45)" fill="#f0f0f0"/>
        <rect id="Rectangle_387" data-name="Rectangle 387" width="11.314" height="0.875" transform="translate(9.507 9.507) rotate(135)" fill="#d5012d"/>
        <rect id="Rectangle_388" data-name="Rectangle 388" width="11.314" height="0.875" transform="translate(16.888 0.888) rotate(135)" fill="#d5012d"/>
        <rect id="Rectangle_382" data-name="Rectangle 382" width="22.627" height="2.513" transform="translate(1.776 0) rotate(45)" fill="#f0f0f0"/>
        <rect id="Rectangle_385" data-name="Rectangle 385" width="11.314" height="0.875" transform="translate(8.27 9.507) rotate(-135)" fill="#d5012d"/>
        <rect id="Rectangle_386" data-name="Rectangle 386" width="11.314" height="0.875" transform="translate(16.888 16.888) rotate(-135)" fill="#d5012d"/>
        <rect id="Rectangle_380" data-name="Rectangle 380" width="17" height="4.012" transform="translate(0.388 6.882)" fill="#f0f0f0"/>
        <rect id="Rectangle_381" data-name="Rectangle 381" width="17.237" height="4.013" transform="translate(6.882 17.507) rotate(-90)" fill="#f0f0f0"/>
        <rect id="Rectangle_378" data-name="Rectangle 378" width="17" height="2.25" transform="translate(0.388 7.763)" fill="#d5012d"/>
        <rect id="Rectangle_379" data-name="Rectangle 379" width="17.237" height="2.25" transform="translate(7.763 17.507) rotate(-90)" fill="#d5012d"/>
      </g>
    </g>
  </svg>
  `,
  FR: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
  <defs>
    <clipPath id="clip-path-1">
      <circle id="Ellipse_307" data-name="Ellipse 307" cx="8" cy="8" r="8" transform="translate(-18900 -245)" fill="#fff" stroke="#707070" stroke-width="1"/>
    </clipPath>
  </defs>
  <g id="Mask_Group_10" data-name="Mask Group 10" transform="translate(18900 245)" clip-path="url(#clip-path)">
    <g id="Group_260" data-name="Group 260" transform="translate(-18900 -245)">
      <rect id="Rectangle_406" data-name="Rectangle 406" width="5.333" height="16" fill="#0955b2"/>
      <rect id="Rectangle_407" data-name="Rectangle 407" width="5.333" height="16" transform="translate(5.333)" fill="#f0f0f0"/>
      <rect id="Rectangle_408" data-name="Rectangle 408" width="5.333" height="16" transform="translate(10.667)" fill="#d5012d"/>
    </g>
  </g>
</svg>
`,
  PL: `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_1141_665" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
  <rect width="24" height="24" fill="white"/>
  </mask>
  <g mask="url(#mask0_1141_665)">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V24H24V0H0Z" fill="#F7FCFF"/>
  <mask id="mask1_1141_665" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V24H24V0H0Z" fill="white"/>
  </mask>
  <g mask="url(#mask1_1141_665)">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 12V24H24V12H0Z" fill="#C51918"/>
  </g>
  </g>
  </svg>
`,
  DE: `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_1141_688)">
  <mask id="mask0_1141_688" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
  <rect width="24" height="24" rx="-1" fill="white"/>
  </mask>
  <g mask="url(#mask0_1141_688)">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 16H24V24H0V16Z" fill="#FFD018"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 8H24V16H0V8Z" fill="#E31D1C"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H24V8H0V0Z" fill="#272727"/>
  </g>
  </g>
  <defs>
  <clipPath id="clip0_1141_688">
  <rect width="24" height="24" rx="12" fill="white"/>
  </clipPath>
  </defs>
  </svg>
  
`,
};
